/**
 * 获取随机推荐稿件列表
 * @param size 随机推荐数量
 * @param category 分区ID
 * @param type -1不区分 0图文 1视频
 * @returns 稿件列表
 */
export async function fetchRelatedPosts(
  resourceId: number,
  resourceType: ResourceType,
  type: -1 | 0 | 1,
  size?: number
): Promise<Post.Info[]> {
  return http
    .get<{ list: Post.Info[] }>('/v1/recommend/related', {
      resource_id: resourceId,
      resource_type: resourceType,
      type,
      size
    })
    .then((res) => res.data.list)
    .catch(() => [])
}
